import { registerMixpanelSuperProperties, unregisterMixpanelSuperProperty } from './mixpanel'

export const OBJECT_REFERENCE_ID_PROPERTY = 'objectReferenceId'
export const REALTY_ID_PROPERTY = 'realtyId'

export interface OrderFlowProperty {
  objectReferenceId: string | null
  realtyId: string | null
}

/** The flow whose property the super properties currently describe. */
let currentOwner: symbol | null = null

/**
 * Stamps every later event with the property an order flow is about (ISSUE-3932), so a funnel step can be broken
 * down per property and joined to the server-side purchase. A value that is not known (yet, or any more) is
 * unregistered rather than reported as null.
 */
export const trackOrderFlowProperty = (owner: symbol, { objectReferenceId, realtyId }: OrderFlowProperty) => {
  currentOwner = owner
  const values: [string, string | null][] = [[OBJECT_REFERENCE_ID_PROPERTY, objectReferenceId], [REALTY_ID_PROPERTY, realtyId]]
  values.forEach(([name, value]) => {
    if (value) registerMixpanelSuperProperties({ [name]: value })
    else unregisterMixpanelSuperProperty(name)
  })
}

/**
 * Ends the property context when its flow unmounts. A no-op when a newer flow has taken over: React renders the
 * next flow before it runs the previous one's unmount cleanup.
 */
export const endOrderFlowProperty = (owner: symbol) => {
  if (currentOwner !== owner) return
  currentOwner = null
  unregisterMixpanelSuperProperty(OBJECT_REFERENCE_ID_PROPERTY)
  unregisterMixpanelSuperProperty(REALTY_ID_PROPERTY)
}
